var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"page-content"},[(_vm.showTitle)?_c('header',{staticClass:"content-title",style:({
			"background":_vm.headerColor,
			"height":_vm.headerHeight,
			"line-height":_vm.headerHeight,
			"border-bottom-color":_vm.borderColor
		})},[_vm._t("content-title")],2):_vm._e(),_vm._v(" "),_c('section',{staticClass:"content-body",style:({
			"height": _vm.showTitle ? (_vm.headerHeight ? "calc(100% - "+_vm.headerHeight+")" : "calc(100% - 49px)") : "100%",
			"background": _vm.bodyColor
		})},[_c('div',{staticClass:"content-label"},[(_vm.showLabel)?_c('div',{staticClass:"label-title-box",class:{'have-label-title': _vm.showTitle}},[_vm._t("label-title")],2):_vm._e(),_vm._v(" "),_c('el-scrollbar',{style:({"height": _vm.showLabel ? "calc(100% - 34px)" : "100%"})},[_c('div',{staticClass:"label-body"},[_vm._t("content-body")],2)])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd3d3756","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-body.vue
// module id = null
// module chunks = 